
















import { defineComponent } from '@vue/composition-api';
import ALink from '@/components/common/a-link/a-link.vue';

const name = 'ttam-age-alert';
export default defineComponent({
  name,
  components: {
    ALink,
  },
  props: {
    showUsU18Text: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const learnMoreLink = '/help/article/age-targeting-restrictions?redirected=2';

    return {
      name,
      learnMoreLink,
    };
  },
});
